
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portfolio/[slug]",
      function () {
        return require("private-next-pages/portfolio/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portfolio/[slug]"])
      });
    }
  